import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-co-so-company-info-vung-trong-view',
  templateUrl: './co-so-company-info-vung-trong-view.component.html',
  styleUrls: ['./co-so-company-info-vung-trong-view.component.css']
})
export class CoSoCompanyInfoVungTrongViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
